import * as React from 'react';
import * as ReactDOM from 'react-dom';
import * as ReactRouterDOM from 'react-router-dom';
import * as FBHistory from 'history';
import * as qiankun from 'qiankun';
import * as classnames from 'classnames';
import * as classnamesBind from 'classnames/bind';
import * as axios from 'axios';
import * as redux from 'redux';
import * as qs from 'qs';
import * as dayjs from 'dayjs';
import * as ReactRedux from 'react-redux';
import * as numeral from 'numeral';
import * as MedlinkerFundamental from '@medlinker/fundamental';
import * as MedlinkerApiToolRequest from '@medlinker/apitool/request';
import * as MedlinkerRem from '@medlinker/rem';
import * as MedlinkerStorage from '@medlinker/storage';
import * as MedlinkerBrowserTracker from '@medlinker/data-tracker/browser';
import * as microShared from '../shared';

function registGlobalModule(global: any, modules: any) {
  Object.keys(modules).forEach(k => {
    global[k] = modules[k];
  });
}

MedlinkerRem.init({ designWidth: 375, maxRatio: 2, rootValue: 50 });

registGlobalModule(window, {
  React,
  ReactDOM,
  ReactRouterDOM,
  ReactRedux,
  qiankun,
  axios,
  redux,
  qs,
  dayjs,
  classnames,
  classnamesBind,
  FBHistory,
  MedlinkerFundamental,
  MedlinkerApiToolRequest,
  MedlinkerStorage,
  MedlinkerRem,
  microShared,
  MedlinkerBrowserTracker,
  numeral,
});
